import { cloneElement } from 'react'
import reactStringReplace from 'react-string-replace'

import type { ReactElement } from 'react'

export const parseBoldMarkup = (text: string, template: ReactElement) =>
  reactStringReplace(text, /<strong>(.*?)<\/strong>/g, (match, i) =>
    cloneElement(template, { key: i }, match)
  )
